import { Column } from 'hooks/useMuiTableBuilderV2';

export enum Columns {
  Checkbox = 'checkbox',
  Copy = 'copy',
  Impersonation = 'impersonation',
  AccountId = 'account_id',
  Name = 'name',
  Email = 'email',
  Role = 'role_name',
  LastActive = 'last_active',
  IsActive = 'is_active',
  SignInStatus = 'login_enabled',
}

const checkboxColumn: Column = {
  id: Columns.Checkbox,
};

const copyColumn: Column = {
  id: Columns.Copy,
};

const impersonationColumn: Column = {
  id: Columns.Impersonation,
};

const accountIdColumn: Column = {
  id: Columns.AccountId,
  label: 'Account ID',
};

const nameColumn: Column = {
  id: Columns.Name,
  label: 'Name',
};

const emailColumn: Column = {
  id: Columns.Email,
  label: 'Email',
};

const isActiveColumn: Column = {
  id: Columns.IsActive,
  label: 'Is Activated',
};

// Not "Status": in Galaxy that is the organization's state (GLX-2014).
const signInStatusColumn: Column = {
  id: Columns.SignInStatus,
  label: 'Sign-in Status',
  tooltip: 'Active or Inactive: whether the member can sign in to Mosaic.',
  sortDisabled: true,
};

const roleColumn: Column = {
  id: Columns.Role,
  label: 'Role',
};

const lastActiveColumn: Column = {
  id: Columns.LastActive,
  label: 'Last Active',
};

const baseColumns = [
  checkboxColumn,
  copyColumn,
  impersonationColumn,
  accountIdColumn,
  nameColumn,
  emailColumn,
  roleColumn,
  lastActiveColumn,
  isActiveColumn,
];

/** Sign-in Status sits beside Is Activated, behind memberManagementTableV2Flag. */
export const getColumns = ({ showSignInStatus }: { showSignInStatus: boolean }): Column[] =>
  showSignInStatus ? [...baseColumns, signInStatusColumn] : baseColumns;
